import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Form, notification } from "antd";
import { connect } from "react-redux";
import { languageLable } from "utilities/helpers";
import API from "../../../api/api";

var api;
class RegisterVarificationButton extends Component {
  constructor(props) {
      super(props);
      api = new API();
      this.state = {
          submitAction: null,
          loading1: false,
          loading2: false,
      };
    }

  static getDerivedStateFromProps(props) {
      if (props.isLoggedIn === true) {
          if (props.isVerified === true) {
              props.history.push("/");
          } else {
              props.history.push("/account/register-verify-btn");
          }
      }
      
    return false;
  }

  handleFeatureWillUpdate(e) {
    e.preventDefault();
    notification.open({
      message: "Opp! Something went wrong.",
      description: "This feature has been updated later!",
      duration: 500,
    });
  }

    onFinish = (values) => {
        if (this.state.submitAction === "verify") {
            this.handleVerify(values);
        } else if (this.state.submitAction === "change") {
            this.handleChange(values);
        }
    };

    handleVerify = async (values) => {

        const { selectedLanguageData } = this.props.app;

        if (this.props.auth.registerRequestData) {
            let payload = {
                isdCode: this.props.auth.registerRequestData.isdCode,
                mobile: this.props.auth.registerRequestData.mobile,
                email: this.props.auth.registerRequestData.email
            };

            api
                .post("ChangeEmailMobileOTP", {
                    data: payload,
                })
                .then((response) => {
                    if (response.StatusCode === 200 && response.Result) {
                        notification.success({
                            message: languageLable(selectedLanguageData, "OTP successfully sent!"),
                        });
                        localStorage.setItem("validateapiroute", "ValidateEmailAndMobileOtp");
                        this.props.history.push("/account/register-varify-existing");
                    } else {
                        this.setState({ loading1: false, loading2: false });
                        notification.info({
                            message: "info",
                            description: languageLable(selectedLanguageData, response.StatusMessage),
                        });
                    }
                });
        } else {
        }       
    };

    handleChange = async (values) => {
        this.props.history.push("/account/register-varify-change");
    };

  onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };


  render() {
    const { selectedLanguageData } = this.props.app;

    return (
      <div className="ps-my-account">
        <div className="container">
          <Form
            className="ps-form--account"
                    onFinish={this.onFinish()}

            onFinishFailed={() => this.onFinishFailed()}
          >
            <ul className="ps-tab-list">
              <li className="active">
                <Link to="/account/login">
                  {languageLable(selectedLanguageData, "Verify Email / Mobile")}
                </Link>
              </li>
            </ul>
            <div className="ps-tab active" id="sign-in">
              <div className="ps-form__content">
                <div className="form-group submit">
                                <button type="submit" className="ps-btn ps-btn--fullwidth" disabled={this.state.loading1} onClick={() => this.setState({ loading1: true, submitAction: "verify" })}>
                                    {this.state.loading1
                                        ? languageLable(selectedLanguageData, "Loading...")
                                        : languageLable(selectedLanguageData, "Verify Existing Email / Mobile") }
                  </button>
                    </div>

                    <div className="form-group submit">
                                <button type="submit" className="ps-btn ps-btn--fullwidth" disabled={this.state.loading2} onClick={() => this.setState({ loading2: true, submitAction: "change" })}>
                                    {this.state.loading2
                                        ? languageLable(selectedLanguageData, "Loading...")
                                        : languageLable(selectedLanguageData, "Change Email / Mobile")}
                        </button>
                    </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps)(withRouter(RegisterVarificationButton));
